<!--
  @component
  Generates an SVG column chart.
 -->
<script>
  import { getContext } from 'svelte';

  const { data, yGet, x, yRange, y, width } = getContext('LayerCake');

  /** @type {Boolean} [false] - Show the numbers for each column */
  export let showLabels = false;

  $: columnHeight = d => {
    return $yRange[0] - $yGet(d);
  };

  $: columnWidth = ($width) / ($data.length);
</script>

<g class="column-group">
  {#each $data as d, i}
    {@const colHeight = columnHeight(d)}
    {@const colWidth = columnWidth}
    {@const yValue = $y(d)}
    <rect
      class='group-rect'
      data-id="{i}"
      data-range="{$x(d)}"
      data-count="{yValue}"
      x="{columnWidth * (i)}"
      y="{$yGet(d)}"
      width="{colWidth}"
      height="{colHeight}"
    />
  {/each}
</g>

<style>
  rect {
    fill: var(--color-dirt);
    stroke: #000;
    stroke-width: 1.2px;
  }
</style>